export var SettingsInteraction;
(function (SettingsInteraction) {
    SettingsInteraction[SettingsInteraction["SignOut"] = 0] = "SignOut";
    SettingsInteraction[SettingsInteraction["GetTipsForWidgets"] = 1] = "GetTipsForWidgets";
    SettingsInteraction[SettingsInteraction["GiveFeedback"] = 2] = "GiveFeedback";
    SettingsInteraction[SettingsInteraction["PrivacyDashboard"] = 3] = "PrivacyDashboard";
    SettingsInteraction[SettingsInteraction["LearnMore"] = 4] = "LearnMore";
    SettingsInteraction[SettingsInteraction["ManageYourNewsAndInterests"] = 5] = "ManageYourNewsAndInterests";
    SettingsInteraction[SettingsInteraction["PrivacyStatement"] = 6] = "PrivacyStatement";
    SettingsInteraction[SettingsInteraction["TermsOfUse"] = 7] = "TermsOfUse";
    SettingsInteraction[SettingsInteraction["CTASettingToggledOn"] = 8] = "CTASettingToggledOn";
    SettingsInteraction[SettingsInteraction["CTASettingToggledOff"] = 9] = "CTASettingToggledOff";
    SettingsInteraction[SettingsInteraction["ComplianceLink"] = 10] = "ComplianceLink";
    SettingsInteraction[SettingsInteraction["LanguageRegionSettings"] = 11] = "LanguageRegionSettings";
    SettingsInteraction[SettingsInteraction["SignInAddAccount"] = 12] = "SignInAddAccount";
    SettingsInteraction[SettingsInteraction["VerifyAccount"] = 13] = "VerifyAccount";
    SettingsInteraction[SettingsInteraction["SignInWithLocalAccount"] = 14] = "SignInWithLocalAccount";
    SettingsInteraction[SettingsInteraction["CPRAPrivacy"] = 15] = "CPRAPrivacy";
    SettingsInteraction[SettingsInteraction["FindMoreWidgets"] = 16] = "FindMoreWidgets";
    SettingsInteraction[SettingsInteraction["SettingToggleInteracted"] = 17] = "SettingToggleInteracted";
    SettingsInteraction[SettingsInteraction["LaunchFeedStorePage"] = 18] = "LaunchFeedStorePage";
    SettingsInteraction[SettingsInteraction["ConsumerHealthPrivacy"] = 19] = "ConsumerHealthPrivacy";
})(SettingsInteraction || (SettingsInteraction = {}));
export var WidgetPickerInteraction;
(function (WidgetPickerInteraction) {
    WidgetPickerInteraction[WidgetPickerInteraction["AddWidget"] = 0] = "AddWidget";
    WidgetPickerInteraction[WidgetPickerInteraction["FindMoreWidgets"] = 1] = "FindMoreWidgets";
    WidgetPickerInteraction[WidgetPickerInteraction["LearnMore"] = 2] = "LearnMore";
    WidgetPickerInteraction[WidgetPickerInteraction["GiveFeedback"] = 3] = "GiveFeedback";
})(WidgetPickerInteraction || (WidgetPickerInteraction = {}));
